















import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsMoney from "@/design-system/components/Money/JdsMoney.vue"
@Component({
    components: {JdsMoney, JdiPreview, JdiDocs, JdiContent}
})
export default class Money extends Vue {
  value = 12300;
}
